import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SocialMediaBarComponent } from '../../shared/components/social-media-bar/social-media-bar.component';
import { MatCard } from '@angular/material/card';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatTooltipModule, SocialMediaBarComponent, MatCard],
})
export class FooterComponent implements OnInit {
  year: number = new Date().getFullYear();
  version = environment.version;

  constructor() {}

  ngOnInit(): void {}
}
